import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import vant from 'vant'
import { Lazyload } from 'vant'

import axios from './commons/AxiosMethod.js'
import tools from './commons/tools.js'
import 'vant/lib/index.css'

createApp(App).use(vant).use(Lazyload, { lazyComponent: true }).use(store).use(router).use(axios).use(tools).mount("#app")

